import { useEffect } from "react";

export function useHideBrandLoader() {
  useEffect(() => {
    const el = document.getElementById("nk-loader");
    if (!el) return;

    el.classList.add("nk-done");
    const timeout = window.setTimeout(() => el.remove(), 450);
    return () => window.clearTimeout(timeout);
  }, []);
}